module.exports = __webpack_public_path__ + "static/main5_sp-647b50370db0252e13a33ca15f9fe659.jpg";